module.exports = __webpack_public_path__ + "static/media/peterArt4.8178d9c5.jpg";